export const parkingEventsSelector = (state) => state.parkingEvents;
